<template>
    <div class="main-wrap profile-page">
        <div class="profile-header row">
            <div class="left-profile-header col-12 col-md-3">
                <div class="profile-avatar">
                    <q-avatar class="profile-image">
                        <img class="avatar-border" :src="profileImage" />
                        <div class="overlay" @click="showUploadImage">
                            <q-icon
                                name="upload"
                                color="white"
                                size="52px"
                            ></q-icon>
                        </div>
                    </q-avatar>
                    <h5>{{ userFirstAndLastName }}</h5>
                    <p>{{ isAuthenticated ? user.occupation : null }}</p>
                </div>
            </div>
            <div class="right-profile-header col-12 col-md-9">
                <h3 class="capitalize-text">{{ $t($route.meta.title) }}</h3>
                <MobiProfileMenu />
            </div>
        </div>
        <div class="profile-inner-wrap row">
            <div class="profile-menu col-12 col-md-3">
                <ProfileMenu />
            </div>
            <div class="profile-content col-12 col-md-9">
                <router-view></router-view>
            </div>
        </div>
        <UploadImage
            :show="uploadImage.show"
            :created-by="isAuthenticated ? user.id : null"
            @toggle-dialog="toggleUploadImage"
            @select-image="selectImage"
        />
    </div>
</template>

<script>
import ProfileMenu from '@/components/ProfileMenu'
import MobiProfileMenu from '@/components/MobiProfileMenu'
import UploadImage from '@/local-shared/components/UploadImage'
import base64 from '@/local-shared/mixins/base64'
import notify from '@/local-shared/mixins/notify'
import picturesService from '@/services/pictures'
import usersService from '@/services/modules/users'
import encoders from '@/helpers/encoders'
import store from '@/store'
import _ from 'lodash'
import env from '@/.env.js'

const loadingKeys = {
    fetchingPicture: 'fetching-picture',
    savingData: 'saving-data',
}

export default {
    name: 'Profile',

    components: {
        ProfileMenu,
        MobiProfileMenu,
        UploadImage,
    },

    mixins: [base64, notify],

    data() {
        return {
            profileImage: '',
            uploadImage: {
                show: false,
            },
        }
    },

    computed: {
        isAuthenticated() {
            return store.getters['session/isAuthenticated']
        },

        user() {
            let user
            if (this.isAuthenticated) {
                user = store.getters['session/user']
            }
            return user
        },

        userFirstAndLastName() {
            if (this.user) {
                let nameWords = _.words(this.user.first_name)
                return nameWords.length == 1
                    ? nameWords[0]
                    : nameWords[0] + ' ' + nameWords[nameWords.length - 1]
            } else {
                return ''
            }
        },
    },

    async created() {
        if (this.user && this.user.user_picture_id != null) {
            this.profileImage = this.getImage(this.user.user_picture_id)
        } else {
            this.profileImage = require('@/assets/images/user_avatar.png')
        }
    },

    methods: {
        getImage(pictureId) {
            return env.endpoint_backend + '/pictures/' + pictureId
        },

        selectImage(picture) {
            this.profileImage = this.getImage(picture.id)
            this.user.user_picture_id = picture.id
            this.savePersonnalData()
        },

        showUploadImage() {
            this.uploadImage.show = true
        },

        toggleUploadImage() {
            this.uploadImage.show = !this.uploadImage.show
        },

        async fetchPicture(pictureId) {
            this.loadingAdd(loadingKeys.fetchingPicture)

            let response = await picturesService.retrieveById(pictureId)

            if (response.status === 200) {
                this.profileImage = encoders.arrayBufferToBase64(response)
            } else {
                this.notifyError(response)
            }
            this.loadingRemove(loadingKeys.fetchingPicture)
        },

        async savePersonnalData() {
            this.loadingAdd(loadingKeys.savingData)

            let parameters = { data: [this.user] }

            let response = await usersService.update(parameters)

            if (response.status === 200) {
                this.$q.notify({
                    type: 'positive',
                    message: this.$t('notify.profile_updated'),
                })
                store.dispatch('session/setUser', { ...this.user })
            } else {
                this.$q.notify({
                    type: 'negative',
                    message: this.$t('notify.error_occurred', {
                        message: response.data.message,
                    }),
                })
            }

            this.loadingRemove(loadingKeys.savingData)
        },
    },
}
</script>
